module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('headroom', {
    attrs: {
      "z-index": 1000
    }
  }, [_c('header', {
    staticClass: "app__nav",
    class: {
      'app__nav--collapse': _vm.collapseMenu
    }
  }, [_c('div', {
    staticClass: "app__nav__mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "app__nav__container"
  }, [_c('div', {
    staticClass: "clearfix app__nav__container__main"
  }, [_c('router-link', {
    staticClass: "app__nav__container__main__brand",
    attrs: {
      "to": {
        'name': 'overview'
      }
    }
  }, [_c('div', {
    staticClass: "sr-only"
  }, [_vm._v("\n            ICIJ\n          ")])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-link btn-lg float-right mt-2 app__nav__container__main__hamburger",
    on: {
      "click": function($event) {
        _vm.toggleMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bars fa-2x"
  })])], 1), _vm._v(" "), _c('ul', {
    staticClass: "app__nav__container__menu list-unstyled",
    class: {
      'app__nav__container__menu--collapse': _vm.collapseMenu
    }
  }, [_c('li', {
    staticClass: "list-unstyled-item app__nav__container__menu__item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.icij.org/investigations/paradise-papers/",
      "target": "_blank"
    }
  }, [_vm._v("\n            Paradise Papers "), _c('i', {
    staticClass: "fa fa-external-link ml-1 app__nav__container__menu__item__new"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item app__nav__container__menu__item"
  }, [_c('a', {
    attrs: {
      "href": "https://offshoreleaks.icij.org",
      "target": "_blank"
    }
  }, [_vm._v("\n            Offshore Leaks "), _c('i', {
    staticClass: "fa fa-external-link ml-1 app__nav__container__menu__item__new"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item app__nav__container__menu__item"
  }, [_c('a', {
    attrs: {
      "href": "https://www.icij.org/",
      "target": "_blank"
    }
  }, [_vm._v("\n            ICIJ "), _c('i', {
    staticClass: "fa fa-external-link ml-1 app__nav__container__menu__item__new"
  })])]), _vm._v(" "), _c('li', {
    staticClass: "list-unstyled-item app__nav__container__menu__item app__nav__container__menu__item--share"
  }, [_c('share', {
    staticClass: "text-left p-3"
  })], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-553bd20e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppNav.vue
// module id = 599
// module chunks = 1